import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href", "target", "disabled"]
const _hoisted_2 = { key: 0 }

import { computed } from 'vue';
import IconLoading from '../icons/IconLoading.vue';

// Props with default values

export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    url: { default: '#' },
    text: { default: '' },
    target: { default: '_self' },
    type: { default: 'primary' },
    size: { default: 'default' },
    iconPosition: { default: 'right' },
    style: { default: 'default' },
    hasBackground: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {



// Computed classes for the button
const classes = computed(() => {
    let baseClasses = ['btn'];

    // Type
    baseClasses.push(`btn-${__props.type}`);

    // Size
    baseClasses.push(`size-${__props.size}`);

    // Style
    baseClasses.push(`style-${__props.style}`);

    // Background
    if (__props.hasBackground) {
        baseClasses.push('btn-bg');
    } else {
        baseClasses.push('btn-no-bg');
    }

    // Loading
    if (__props.loading || __props.disabled) {
        baseClasses.push('disabled');
    }

    // Icon left
    if (__props.iconPosition === 'left') {
        baseClasses.push('icon-left');
    }

    return baseClasses.join(' ');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(classes.value),
    href: _ctx.url,
    target: _ctx.target,
    disabled: _ctx.disabled ?? false
  }, [
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.text), 1))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(IconLoading, { key: 1 }))
      : _renderSlot(_ctx.$slots, "default", { key: 2 })
  ], 10, _hoisted_1))
}
}

})